module.exports = __webpack_public_path__ + "static/media/rain.d18c0052.svg";